// extracted by mini-css-extract-plugin
export default {"container":"D8Qbm2","subtitle":"t30jza"};